import { render, staticRenderFns } from "./LeftBarNavItem.vue?vue&type=template&id=29bc871e&scoped=true&"
import script from "./LeftBarNavItem.vue?vue&type=script&lang=ts&"
export * from "./LeftBarNavItem.vue?vue&type=script&lang=ts&"
import style0 from "./LeftBarNavItem.vue?vue&type=style&index=0&id=29bc871e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29bc871e",
  null
  
)

export default component.exports